/**
 * Web shim for @react-native-community/blur.
 *
 * On native, BlurView is a native UIVisualEffectView / RenderScript layer.
 * On web we achieve the same visual result with CSS backdrop-filter, which
 * has ~96 % browser support (caniuse).  Unsupported browsers fall back to
 * the `reducedTransparencyFallbackColor` prop, exactly matching the native
 * fallback behaviour.
 */

import React from 'react';
import { View } from 'react-native';

export const BlurView = ({
  children,
  style,
  blurAmount = 10,
  reducedTransparencyFallbackColor = 'rgba(0, 0, 0, 0.5)',
  // Accepted but unused on web
  blurType: _blurType,
  ...rest
}) => {
  const blurStyle = {
    backdropFilter: `blur(${blurAmount}px)`,
    WebkitBackdropFilter: `blur(${blurAmount}px)`,
    // Applied when backdrop-filter is not supported
    backgroundColor: reducedTransparencyFallbackColor,
  };

  return React.createElement(
    View,
    { ...rest, style: [style, blurStyle] },
    children,
  );
};

export default BlurView;
